// extracted by mini-css-extract-plugin
module.exports = {"login":"resetPassFromToken_login__1B18Q","button":"resetPassFromToken_button__2MyBv","container":"resetPassFromToken_container__2H8Oe","logo":"resetPassFromToken_logo__3GvcI"};